import styled from 'styled-components';

import { BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const Layer = styled('div')`
	position: fixed;
	left: 0;
	top: 0;
	z-index: 100;
	width: 100%;
	height: 100%;
	background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 20)};
`;

const DropTarget = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

export {
	Layer,
	DropTarget,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/FilesDndUploader/styles.ts